import { useState } from "react";
import api from "../Services/api";
import Recaptcha from "react-recaptcha";

const Mensagem = (props: any) => {

    const hash = window.location.hash.substring(1);
    const [errorEmail, setErrorEmail] = useState("");
    const [error, setError] = useState("");
    // const [fileName, setFileName] = useState("");
    const [recaptcha, setRecaptcha] = useState(false);
    // Handle input 
    const [form, setForm] = useState({
        identificar: "sim",
        matricula: 0,
        nome: "",
        email: "",
        telefone: "",
        celular: "",
        assunto: "",
        comentario: "",
        anexo: []
    });


    const buttonMessage = (data: string) => {

        switch (data) {
            case "Diretor":
                return (
                    <h3 className="order-2 order-lg-1 blockquoteCorrect"><strong style={{ color: "#E87400" }}>O Diretor</strong>  da Forluz quer saber sua opinião, envie suas sugestões ou críticas.</h3>
                );
            case "Presidente":
                return (
                    <h3 className="order-2 order-lg-1 blockquoteCorrect"><strong style={{ color: "#E87400" }}>O Presidente</strong>  da Forluz quer saber sua opinião, envie suas sugestões ou críticas.</h3>
                );
            case "Gerente":
                return (
                    <h3 className="order-2 order-lg-1 blockquoteCorrect"><strong style={{ color: "#E87400" }}>O Gerente</strong>  da Forluz quer saber sua opinião, envie suas sugestões ou críticas.</h3>
                );
            case "Coordenador":
                return (
                    <h3 className="order-2 order-lg-1 blockquoteCorrect"><strong style={{ color: "#E87400" }}>O Coordenador</strong>  da Forluz quer saber sua opinião, envie suas sugestões ou críticas.</h3>
                );
            case "Supervisor":
                return (
                    <h3 className="order-2 order-lg-1 blockquoteCorrect"><strong style={{ color: "#E87400" }}>O Supervisor</strong>  da Forluz quer saber sua opinião, envie suas sugestões ou críticas.</h3>
                );
            case "Diretora":
                return (
                    <h3 className="order-2 order-lg-1 blockquoteCorrect"><strong style={{ color: "#E87400" }}>A Diretora</strong>  da Forluz quer saber sua opinião, envie suas sugestões ou críticas.</h3>
                );
            default:
                return (
                    <h3 className="order-2 order-lg-1 blockquoteCorrect">A Forluz quer saber sua opinião, envie suas sugestões ou críticas.</h3>
                );
        }
    }

    const handleChange = (event: any) => {
        const { name, value } = event.target;
        // telefone/celular mask
        if ((name === "telefone" || name === "celular") && value !== "") {
            var valor = value;
            if (isNaN(valor.replace("(", "").replace(")", "").replace(" ", "").replace("-", ""))) {
                valor = valor.replace(/[^\d.-]/g, '');
            }
            valor = valor.replace("(", "").replace(")", "").replace(" ", "").replace("-", "");
            if (valor.length === 0) valor = "(";
            if (valor[0] !== "(") valor = "(" + valor;
            if (valor.length === 3) valor = valor + ") ";
            if (valor.length > 3 && valor[3] !== ")") valor = valor.substring(0, 3) + ") " + valor.substring(3);
            if (valor.length > 9 && valor[9] !== "-") valor = valor.substring(0, 9) + "-" + valor.substring(9);
            if (valor.length === 15 && valor[10] !== "-") valor = valor.replace("-", "").substring(0, 10) + "-" + valor.replace("-", "").substring(10);

            if (name === "telefone") $("#telefone").val(valor);
            else $("#celular").val(valor)

            setForm({ ...form, [name]: valor.replace("(", "").replace(")", "") });
            /* setForm({ ...form, [name]: valor.replace("(","").replace(")","").replace(" ","").replace("-","") }); */
        }
        else {
            setForm({ ...form, [name]: value });
        }
        if (form.assunto && form.comentario && form.email && form.nome) {
            $("#botaoEnviar").removeClass("disabled");
            /* $("#botaoEnviar").prop("disabled", true); */
        }
        else {
            $("#botaoEnviar").addClass("disabled");
            /* $("#botaoEnviar").prop("disabled", false); */
        }
    };

    function handleSubmit(event: any) {

        event.preventDefault();

        resetErrors(); //apaga todas as mensagens de erro

        if (!/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(form.email)) return (setErrorEmail("* Digite um email válido"));

        if (form.nome === "" || form.comentario === "" || form.assunto === "") return (setError("* Preencha todos os campos"));

        if (!recaptcha) return (setError("* Confirme que você não é um robô"));

        var regExp = /[a-zA-Z]/g;

        if (regExp.test(form.matricula.toString())) return (setError("* Digite uma Matricula válida"));

        var _origem = hash ? hash : 'Fale Conosco';

        api.post("/InsereFaleConosco", {
            Origem: _origem,
            Matricula: form.matricula,
            Nome: form.nome,
            Email: form.email,
            Telefone: form.telefone,
            Celular: form.celular,
            Assunto: form.assunto,
            Mensagem: form.comentario,
        }).then((response) => {

            setError("Mensagem enviada com sucesso!");
            $("#Matricula").val(""); $("#Nome").val(""); $("#email").val(""); $("#telefone").val(""); $("#celular").val(""); $("#Mensagem").val("");

            setTimeout(() => {
                setError("");
                //clear form 
                setForm({
                    identificar: "sim",
                    matricula: 0,
                    nome: "",
                    email: "",
                    telefone: "",
                    celular: "",
                    assunto: "",
                    comentario: "",
                    anexo: []
                })

            }, 3000);
        }).catch((err) => {
            throw new Error(err);
        });

    }

    function recaptchaSetFalse() {
        setRecaptcha(false);
    }

    function recaptchaSetTrue() {
        setRecaptcha(true);
        setError("");
    }

    function resetErrors() {
        setErrorEmail("");
        setError("");
    }

    useState(() => {
        setError("* Digite uma Matricula válida")
    });

    return (
        <div className="_the-content pb-10">
            <div className='container'>
                <div className="row justify-content-center">

                    <div className="col-md-10 col-lg-8 col-xl-6">
                        {hash && <>{buttonMessage(hash)}<hr /></>}
                        <div className="_form pb-8">
                            <h3 className="mb-5">Envie sua mensagem</h3>
                            <form action="../pages/canal-de-denuncia-acompanhar.html">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="_form__line">
                                            <label className="mb-2"> Você é participante? </label>
                                            <div className="box-radios">
                                                <input onChange={e => handleChange(e)} type="radio" name="identificar" value="sim" id="sim" className="first" />
                                                <label htmlFor="sim" className="box-radios__label first">
                                                    <svg width="14" height="19" viewBox="0 0 14 19" xmlns="http://www.w3.org/2000/svg">
                                                        <path className="ico-svg" d="M0.333984 18.3333C0.333984 16.5651 1.03636 14.8694 2.28661 13.6192C3.53685 12.369 5.23254 11.6666 7.00065 11.6666C8.76876 11.6666 10.4645 12.369 11.7147 13.6192C12.9649 14.8694 13.6673 16.5651 13.6673 18.3333H12.0006C12.0006 17.0072 11.4739 15.7354 10.5362 14.7977C9.5985 13.86 8.32673 13.3333 7.00065 13.3333C5.67457 13.3333 4.4028 13.86 3.46512 14.7977C2.52744 15.7354 2.00065 17.0072 2.00065 18.3333H0.333984ZM7.00065 10.8333C4.23815 10.8333 2.00065 8.59575 2.00065 5.83325C2.00065 3.07075 4.23815 0.833252 7.00065 0.833252C9.76315 0.833252 12.0006 3.07075 12.0006 5.83325C12.0006 8.59575 9.76315 10.8333 7.00065 10.8333ZM7.00065 9.16658C8.84232 9.16658 10.334 7.67492 10.334 5.83325C10.334 3.99159 8.84232 2.49992 7.00065 2.49992C5.15898 2.49992 3.66732 3.99159 3.66732 5.83325C3.66732 7.67492 5.15898 9.16658 7.00065 9.16658Z" fill="#727272" />
                                                    </svg>
                                                    Sim
                                                </label>

                                                <input onChange={e => handleChange(e)} type="radio" name="identificar" value="nao" id="nao" className="last" />
                                                <label htmlFor="nao" className="box-radios__label last">
                                                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path className="ico-svg" d="M13.166 8.83333C13.8253 8.83333 14.4698 9.02883 15.0179 9.3951C15.5661 9.76137 15.9933 10.282 16.2456 10.8911C16.4979 11.5001 16.5639 12.1704 16.4353 12.817C16.3067 13.4636 15.9892 14.0575 15.523 14.5237C15.0569 14.9899 14.4629 15.3073 13.8163 15.436C13.1697 15.5646 12.4995 15.4986 11.8904 15.2463C11.2813 14.994 10.7607 14.5667 10.3945 14.0186C10.0282 13.4704 9.83268 12.8259 9.83268 12.1667H8.16602C8.1657 12.9754 7.8714 13.7564 7.33794 14.3642C6.80449 14.972 6.06826 15.3651 5.26643 15.4704C4.46461 15.5756 3.65187 15.3857 2.97964 14.9362C2.30741 14.4866 1.82155 13.808 1.61257 13.0268C1.40359 12.2455 1.48575 11.415 1.84374 10.6898C2.20173 9.96465 2.81113 9.39437 3.55841 9.08522C4.30569 8.77607 5.13987 8.74912 5.90554 9.00941C6.67121 9.2697 7.31615 9.79946 7.72018 10.5H10.2785C10.571 9.99305 10.9919 9.57209 11.4988 9.2795C12.0057 8.98692 12.5807 8.83303 13.166 8.83333ZM4.83268 10.5C4.39066 10.5 3.96673 10.6756 3.65417 10.9882C3.34161 11.3007 3.16602 11.7246 3.16602 12.1667C3.16602 12.6087 3.34161 13.0326 3.65417 13.3452C3.96673 13.6577 4.39066 13.8333 4.83268 13.8333C5.27471 13.8333 5.69863 13.6577 6.01119 13.3452C6.32375 13.0326 6.49935 12.6087 6.49935 12.1667C6.49935 11.7246 6.32375 11.3007 6.01119 10.9882C5.69863 10.6756 5.27471 10.5 4.83268 10.5ZM13.166 10.5C12.724 10.5 12.3001 10.6756 11.9875 10.9882C11.6749 11.3007 11.4993 11.7246 11.4993 12.1667C11.4993 12.6087 11.6749 13.0326 11.9875 13.3452C12.3001 13.6577 12.724 13.8333 13.166 13.8333C13.608 13.8333 14.032 13.6577 14.3445 13.3452C14.6571 13.0326 14.8327 12.6087 14.8327 12.1667C14.8327 11.7246 14.6571 11.3007 14.3445 10.9882C14.032 10.6756 13.608 10.5 13.166 10.5ZM12.3327 0.5C13.2167 0.5 14.0646 0.851189 14.6897 1.47631C15.3148 2.10143 15.666 2.94928 15.666 3.83333V6.33333H17.3327V8H0.666016V6.33333H2.33268V3.83333C2.33268 2.94928 2.68387 2.10143 3.30899 1.47631C3.93411 0.851189 4.78196 0.5 5.66602 0.5H12.3327ZM12.3327 2.16667H5.66602C4.78768 2.16667 3.99935 2.95833 3.99935 3.83333V6.33333H13.9993V3.83333C13.9993 2.955 13.2077 2.16667 12.3327 2.16667Z" fill="#727272" />
                                                    </svg>
                                                    Não
                                                </label>

                                                <div className="box-radios__indicator"></div>

                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="_form__line">
                                            <label className="mb-2"> Matrícula </label>
                                            <input id="Matricula" onChange={e => handleChange(e)} type="text" name="matricula" />
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="_form__line">
                                            <label className="mb-2"> Nome completo </label>
                                            <input id="Nome" onChange={e => handleChange(e)} type="text" name="nome" required />
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="_form__line">
                                            <label className="mb-2"> E-mail </label>
                                            <span style={{
                                                fontWeight: 'bold',
                                                marginBlockStart: '10px',
                                                position: 'relative',
                                                left: '15px',
                                                color: 'rgb(232, 116, 0)',
                                            }}>{errorEmail}
                                            </span>
                                            <input id="email" onChange={e => handleChange(e)} type="email" name="email" required />
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="_form__line">
                                            <label className="mb-2"> Telefone (DDD+Número) </label>
                                            {/* <span style={{
                                                fontWeight: 'bold',
                                                marginBlockStart: '10px',
                                                position: 'relative',
                                                left: '15px',
                                                color: 'rgb(232, 116, 0)',
                                            }}>{errorTel}
                                            </span> */}
                                            <input onChange={e => handleChange(e)} type="tel" id="telefone" name="telefone" maxLength={15} />
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="_form__line">
                                            <label className="mb-2"> Celular (DDD+Número) </label>
                                            {/* <span style={{
                                                fontWeight: 'bold',
                                                marginBlockStart: '10px',
                                                position: 'relative',
                                                left: '15px',
                                                color: 'rgb(232, 116, 0)',
                                            }}>{errorCel}
                                            </span> */}
                                            <input onChange={e => handleChange(e)} type="tel" id="celular" name="celular" maxLength={15} />
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="_form__line">
                                            <label className="mb-2"> Assunto de interesse </label>
                                            <label className="select" htmlFor="mes">
                                                <select defaultValue="" onChange={e => handleChange(e)} id="mes" name="assunto" required>
                                                    <option value="" disabled>Selecione</option>
                                                    {/*  {assuntos.map((option) => (
                                                    <option value={option.Title}>{option.Title}</option>
                                                ))} */}

                                                    <option value="Cadastro">Cadastro</option>
                                                    <option value="Comunicação">Comunicação</option>
                                                    <option value="Empréstimo">Empréstimo</option>
                                                    {/* <option value="Empréstimo Especial">Empréstimo Especial</option> */}
                                                    <option value="Investimento">Investimento (Perfis,Rentabilidade)</option>
                                                    <option value="Pagamento de Benefício">Pagamento de Benefício (Contracheque, Datas, Adiantamento quinzenal, Valores creditados, Descontos )</option>
                                                    <option value="Plano A">Plano A - Hotsite</option>
                                                    <option value="Portal">Portal</option>
                                                    <option value="Previdência">Previdência (Requerimentos, Concessão, Cálculo, Simulção, Extrato)</option>

                                                </select>
                                                <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M7.00072 5.17192L11.9507 0.221924L13.3647 1.63592L7.00072 7.99992L0.636719 1.63592L2.05072 0.221924L7.00072 5.17192Z" fill="#727272" />
                                                </svg>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="_form__line">
                                            <label className="mb-2"> Mensagem </label>
                                            <textarea id="Mensagem" onChange={e => handleChange(e)} name="comentario" required maxLength={331}></textarea>
                                        </div>

                                    </div>

                                    <div className="col-12">
                                        {/* <div className="_form__line">
                                            <label className="mb-2"> Arquivos (anexos) </label>
                                            <div className="file-upload-wrapper" data-text={fileName}>
                                                <input onChange={e => handleFile(e)} name="file-upload-field" type="file" className="file-upload-field" />
                                            </div>
                                        </div> */}
                                        <span style={{
                                            fontSize: '28px',
                                            fontWeight: 'bold',
                                            marginBlockStart: '15px',
                                            position: 'relative',
                                            left: '10px',
                                            color: 'rgb(232, 116, 0)',
                                        }}>{error}
                                        </span>
                                    </div>
                                    <div className="col-12">
                                        <div className="_form__line">
                                            <Recaptcha
                                                sitekey="6LeRMMMdAAAAAPEDQGwLU16ZGGXGmMKwcu1R0FUx"
                                                render="explicit"
                                                onloadCallback={recaptchaSetFalse}
                                                verifyCallback={recaptchaSetTrue}
                                                expiredCallback={recaptchaSetFalse}
                                                hl="pt-BR"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="_form__line">
                                            <input onClick={e => handleSubmit(e)} type="submit" value="Enviar" id="botaoEnviar" className="btn disabled transition" />
                                            {/* {<button type="button" onClick={e => handleSubmit(e)} id="botaoEnviar"  className="btn  rounded d-block" disabled> Enviar </button>} */}
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

};
export default Mensagem;